import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import dotenv from 'react-dotenv';
import { getIAAM } from '../../reducer/iaamSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getAreaLevel } from '../../reducer/areaLevelSlice';
import { getDisease } from '../../reducer/diseaseSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';
import { getAmphurDataMap, getProvinceDataMap, getTambonDataMap } from '../../reducer/areaDataSlice';
import { setSpotmap, setSpotmapChecked } from '../../reducer/spotmapSlice';
import { getDengueSetting, setDengueSpotmap } from '../../reducer/dengueSettingSlice';

function SpotMapSetting(props) {
    // const {config} = props;
    const dispatch = useDispatch();
    const { spotmap } = useSelector(getDengueSetting);
    // const provinceData = useSelector(getProvinceData);
    const provinceMap = useSelector(getProvinceDataMap);
    // const amphurData = useSelector(getAmphurData);
    const amphurMap = useSelector(getAmphurDataMap);
    // const tambonData = useSelector(getTambonData);
    const tambonMap = useSelector(getTambonDataMap);
    const iaam = useSelector(getIAAM);
    const area_level = useSelector(getAreaLevel);
    const disease_class = useSelector(getDisease);
    const woy = useSelector(getWeekOfYear);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        
        const getAPI = async () => {
            let access_token = await iaam.getAccessToken();
            // console.log(access_token);
            // console.log(access_token)
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json', 
                    'Authorization': `bearer ${access_token}`
                }
            }
        
            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/d506/get-patients?disease_class=${disease_class}&start_date=${woy.start.from}&end_date=${woy.end.to}`, options);
            const resData = await res.json();
            let errorList = [];
            let tmpData = {};
            let provAttrName = "prov_namt";
            let provAttrCode = "prov_code";
            let ampAttrName = "amp_namt";
            let ampAttrCode = "amp_code";
            let tambonAttrName = "tambon_namt";
            let tambonAttrCode = "tambon_code";
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];
                const tambon_code = element.tambon_code;
                const amphur_code = tambon_code.substr(0, 4);
                const province_code = tambon_code.substr(0, 2);
                const tambon = tambonMap[tambon_code];
                const amphur = amphurMap[amphur_code];
                const province = provinceMap[province_code];
                if (tambon !== undefined && amphur !== undefined && province !== undefined) {
                    const data = {
                        patient_id: element.id,
                        tambon_code: tambon[tambonAttrCode],
                        tambon_name: tambon[tambonAttrName],
                        amphur_code: amphur[ampAttrCode],
                        amphur_name: amphur[ampAttrName],
                        province_code: province[provAttrCode],
                        province_name: province[provAttrName],
                        location: element.geojson,
                        gender: element.gender,
                        age: element.age,
                        treated_date: element.treated_date,
                        onset_date: element.onset_date,
                        color: element.age <= 15 ? "#D92405" : "#0c2271"
                    }
                    if (tmpData[data[`${area_level}_code`]] === undefined) {
                        tmpData[data[`${area_level}_code`]] = [data];
                    } else {
                        tmpData[data[`${area_level}_code`]].push(data);
                    }
                } else {
                    if (tambon === undefined) {
                        errorList.push({
                            level: 'tambon',
                            code: tambon_code
                        })
                    } else if (amphur === undefined) {
                        errorList.push({
                            level: 'amphur',
                            code: tambon_code
                        })
                    } else {
                        errorList.push({
                            level: 'province',
                            code: tambon_code
                        })
                    }
                }
            }
            dispatch(setSpotmap(tmpData));
        }
        if (iaam) {
            if (checked) {
                dispatch(setSpotmap({}));
                dispatch(setSpotmapChecked(true));
                getAPI();   
            } else {
                dispatch(setSpotmap({}));
                dispatch(setSpotmapChecked(false));
            }
        }
    }, [checked, iaam, area_level, disease_class, woy, dispatch])

    useEffect(() => {
        setChecked(spotmap);
    },[spotmap])

    return (
        <>
            <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
                if (disease_class === "1") {
                    dispatch(setDengueSpotmap(event.target.checked));
                } else {
                    setChecked(event.target.checked);
                }
                // setChecked(event.target.checked);
            }}/>} label="ความหนาแน่นของผู้ป่วย" />
        </>
    )
}

export default SpotMapSetting;